import React, { useState, useEffect } from "react";
import { Title, Control, Button, Icon, Box, Fieldset } from "rbx";
import { useMutation } from "react-apollo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BookingForm } from "../../../components/Bookings";
import {
  useCurrentUser,
  useBookingCodeDetails,
  useSystemCodes
} from "../../../utils/hooks";

import { getUTCFormattedDate, ourToast as toast } from "../../../utils";
import { CREATE_BOOKING_MUTATION } from "../../../graphql/Bookings/Bookings.graphql";

const INITIAL_STATE = {
  EmployeeRecIdRef: "",
  BookingCodeRecIdRef: "",
  BookingStartDate: null,
  Comment: "",
  OperatorRecIdRef: null
};

const PTOPage = () => {
  const { data: user } = useCurrentUser();
  const [state, setState] = useState({
    ...INITIAL_STATE,
    BookingDate: new Date().toCorrectDateString(),
    BookingStartDate: new Date().toCorrectDateString()
  });
  const [days, setDays] = useState([]);
  const { data: bkData } = useBookingCodeDetails(state.BookingCodeRecIdRef);
  const [createBooking, { loading }] = useMutation(CREATE_BOOKING_MUTATION);

  const { data: systemCodesData } = useSystemCodes({
    CodeId: "NA-PTO",
    CodeName: "BookCatg"
  });

  const { data: EmployeeTypesCodes } = useSystemCodes({
    CodeName: "EmployeeType",
    CodeId_in: ["D", "M", "MG"]
  });

  const ptoCode = systemCodesData?.[0]?.RecId;

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value });
  };
  const handleDaysChange = arr => {
    setDays(arr);
  };

  useEffect(() => {
    if (user && user.RecId && !state?.OperatorRecIdRef) {
      setState(prev => ({ ...prev, OperatorRecIdRef: user.RecId }));
    }
  }, [user, state]);

  const onSaveClick = async e => {
    e.preventDefault();
    if (!state.BookingCodeRecIdRef || state.BookingCodeRecIdRef === "0") {
      return toast.warning("Select a booking code");
    }

    const bookedTrip = state.BookedTrip
      ? `${
          bkData.BookingCode
            ? `${bkData.BookingCode} ${state.BookedTrip} `
            : `${state.BookedTrip} `
        }`
      : null;

    try {
      if (Array.isArray(days) && days.length >= 1) {
        await Promise.all(
          days.map(day =>
            createBooking({
              variables: {
                data: {
                  EmployeeRecIdRef: parseInt(state.EmployeeRecIdRef),
                  OperatorRecIdRef: parseInt(state.OperatorRecIdRef),
                  BookingCodeRecIdRef: parseInt(state.BookingCodeRecIdRef),
                  Comment: state.Comment,
                  PickupDate: getUTCFormattedDate(
                    new Date(day).getTime() + 1000 * 60 * 60 * 8
                  ),
                  BookingDate: getUTCFormattedDate(state.BookingDate),
                  BookedTrip: bookedTrip
                }
              }
            })
          )
        );
        toast.success("Bookings created successfully");
        setState({
          ...INITIAL_STATE,
          BookingDate: new Date().toCorrectDateString(),
          BookingStartDate: new Date().toCorrectDateString()
        });
        setDays([]);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <form id="add-booking-form" onSubmit={onSaveClick}>
      <header className="page-head">
        <div className="page-head-start">
          <Title color="primary" size={4}>
            PTO Request
          </Title>
        </div>
        <div className="page-head-end">
          <Control>
            <Button
              color="success"
              size="small"
              state={loading ? "loading" : ""}
              type="submit"
            >
              <Icon>
                <FontAwesomeIcon icon="save" />
              </Icon>
              <span>Save</span>
            </Button>
          </Control>
        </div>
      </header>
      <Box>
        <Fieldset loading={loading}>
          <BookingForm
            adding
            bookingCodeWhere={{ CodeCatgRecIdRef: ptoCode }}
            days={days}
            employeeWhere={
              Array.isArray(EmployeeTypesCodes)
                ? {
                    EmployeeTypeRecIdRef_in: EmployeeTypesCodes.map(
                      c => c.RecId
                    )
                  }
                : {}
            }
            state={state}
            user={user}
            onChange={handleChange}
            onDaysChange={handleDaysChange}
          />
        </Fieldset>
      </Box>
    </form>
  );
};
PTOPage.propTypes = {};
export default PTOPage;
